import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ExternalLinkModal({
  externalLinkModal,
  setExternalLinkModal,
}) {
  const handleClose = () => {
    setExternalLinkModal(undefined);
  };

  const handleLinkOpen = () => {
    window.open(externalLinkModal, '_blank').focus();
    handleClose();
  };

  return (
    <Dialog
      open={!!externalLinkModal}
      onClose={handleClose}
      aria-labelledby="external-link-dialog-title"
      aria-describedby="external-link-dialog-description"
    >
      <DialogTitle id="external-link-dialog-title">
        Warning: External Link
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="external-link-dialog-description">
          This is an external link. Please check it carefully before proceeding.
          <div className="my-2 tw-bg-gray-100 dark:tw-bg-gray-900 tw-p-2 tw-rounded tw-border-solid tw-border-1 tw-border-gray-200">
            {externalLinkModal}
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button variant="contained" onClick={handleLinkOpen}>
          Visit this Website
        </Button>
      </DialogActions>
    </Dialog>
  );
}
